/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  IOverviewStatisticsState,
  OVERVIEW_STATISTICS_KEY
} from './overview-statistics.reducer';

const getOverviewStatisticsState = createFeatureSelector<IOverviewStatisticsState>(OVERVIEW_STATISTICS_KEY);

export const getOverviewStatisticsWasteByPerson = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.wasteByPersonData
);

export const areWasteByPersonLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.wasteByPersonLoader,
);

export const getOverviewStatisticsNumberOfWaste = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.numberOfWasteData
);

export const areNumberOfWasteLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.numberOfWasteLoader,
);

export const getOverviewStatisticsWasteByDrug = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.wasteByDrugData
);

export const areWasteByDrugLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.wasteByDrugLoader,
);

export const getOverviewStatisticsNumberOfWitness = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.numberOfWitnessData
);

export const areNumberOfWitnessLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.numberOfWitnessLoader,
);

export const getOverviewStatisticsNumberOfWasteByHospital = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.wasteByHospitalData
);

export const areNumberOfWasteByHospitalLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.wasteByHospitalLoader,
);

export const getOverviewStatisticsNumberOfWitnessByHospital = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.numberOfWitnessByHospitalData
);

export const areNumberOfWitnessByHospitalLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.numberOfWitnessByHospitalLoader,
);

export const getOverviewStatisticsRxInterceptWaste = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.overview.rxInterceptWasteData);

export const areRxInterceptWaste = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.rxInterceptWasteLoader
);

export const getOverviewStatisticsNumberOfStandardWaste = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.numberOfStandardWasteData
);

export const areNumberOfStandardWasteLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.numberOfStandardWasteLoader,
);

export const getOverviewStatisticsRxInterceptWasteByDateRange = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.overview.rxInterceptWasteByDateRangeData);

export const areRxInterceptWasteByDateRangeLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.rxInterceptWasteByDateRangeLoader
);

export const getOverviewStatisticsStandardWastelocation = createSelector(getOverviewStatisticsState, (state: IOverviewStatisticsState) =>
  state.overview.standardWasteLocationData
);

export const areStandardWasteLocationLoaded = createSelector(
  getOverviewStatisticsState,
  (state: IOverviewStatisticsState) => state.loaders.standardWasteLocationLoader,
);

